// extracted by mini-css-extract-plugin
export default {"header":"GuaranteeModal_header__YbrvJ","title":"GuaranteeModal_title__b+U1t","body":"GuaranteeModal_body__CFd3Q","notMargin":"GuaranteeModal_notMargin__9F0Sg"};